import React from 'react'

const TreeIconWithFallback = ({src, alt, width, height, }) => {
    function handleError(e) {
        // e.target.src = process.env.PUBLIC_URL + `/assets/profile_icons/0.png`
        e.target.src = process.env.PUBLIC_URL + `/assets/missing_asset/missing_icon.png`
    }

    return (
        <img
            className={`rounded-full bg-zinc-800 p-0.5`}
            width={width}
            height={height}
            src={src}
            alt={alt}
            onError={(e) => handleError(e)}
        />
    )
}


const RuneIconWithFallback = ({src, alt, width, height, format}) => {
    function handleError(e) {
        // e.target.src = process.env.PUBLIC_URL + `/assets/profile_icons/0.png`
        e.target.src = process.env.PUBLIC_URL + `/assets/missing_asset/missing_icon.png`
    }

    return (
        <img
            className={`rounded-full ${format} bg-zinc-800`}
            width={width}
            height={height}
            src={src}
            alt={alt}
            onError={(e) => handleError(e)}
        />
    )
}

export {TreeIconWithFallback, RuneIconWithFallback}

